import { Injectable } from '@angular/core';
import { Lookup } from '../models/lookup.model';


@Injectable({
  providedIn: 'root'
})
export class TypeService {

  constructor() { }

  getEnumOptions(enumObject: any): Lookup[] {
    return Object.keys(enumObject)
      .filter(key => !isNaN(Number(enumObject[key])))
      .map(key => ({
        id: enumObject[key],
        name: key
      }));
  }

}
